import { id } from 'date-fns/locale';
import { z } from 'zod';

export const beneficiarySchema = z.object({
  tipoMovimentacao: z.string().nonempty('Campo obrigatório'),
  checkbox1: z.boolean().optional(),
  checkbox2: z.boolean().optional(),
});

export const dependenteSchema = z.object({
  id: z.string().nonempty('Campo obrigatório'),
  cpf: z.string().nonempty('Campo obrigatório'),
  nome: z.string().nonempty('Campo obrigatório'),
  dataNascimento: z.string().nonempty('Campo obrigatório'),
  nomeMae: z.string().nonempty('Campo obrigatório'),
  cns: z.string().optional(),
  sexo: z.string().nonempty('Campo obrigatório'),
  estCivil: z.string().nonempty('Campo obrigatório'),
  parentesco: z.string().nonempty('Campo obrigatório'),
});

export const titularSchema = z.object({
  id: z.string().nonempty('Campo obrigatório'),
  cpf: z.string().nonempty('Campo obrigatório'),
  nome: z.string().nonempty('Campo obrigatório'),
  OrgaoExp: z.string().nonempty('Campo obrigatório'),
  cns: z.string().optional(),
  dataNascimento: z.string().nonempty('Campo obrigatório'),
  sexo: z.string().nonempty('Campo obrigatório'),
  estCivil: z.string().nonempty('Campo obrigatório'),
  endereco: z.optional(
    z.object({
      cep: z.optional(z.string().min(8, { message: 'Campo obrigatório' })),
      bairro: z.optional(z.string()),
      uf: z.optional(z.string()),
      cidade: z.optional(z.string()),
      logradouro: z.optional(z.string()),
      numero: z.optional(z.string().min(1, { message: 'Campo obrigatório' })),
      complemento: z.optional(z.string()),
    }),
  ),
  celular: z.string().optional(),
  telefone1: z.string().optional(),
  telefone2: z.string().optional(),
  nomeMae: z.string().nonempty('Campo obrigatório'),
  email: z.string().optional(),
  plano: z.string().nonempty('Campo obrigatório'),
  dependentes: z.array(dependenteSchema).optional(),
});

export type BeneficiaryFormSchema = z.infer<typeof beneficiarySchema>;
export type TitularFormSchema = z.infer<typeof titularSchema>;
export type DependenteFormSchema = z.infer<typeof dependenteSchema>;
